import Components from "../components";

class StatusPageIncidentForm extends Components.Base {
  initialize() {
    this.$buildTypeInputs = this.$el.find(".build-type-inputs");
    this.$buildTypeToggle = this.$el.find(
      'input[name="status_page_incident[build_type]"]',
    );
  }

  bind() {
    this.$buildTypeToggle.on("change", (evt) => {
      const $target = $(evt.target);
      const $currentInputs = this.$el.find(
        `.build-type-inputs[data-build-type=${$target.val()}`,
      );
      this.$buildTypeInputs.find("input, textarea").prop("disabled", true);
      $currentInputs.find("input, textarea").prop("disabled", false);
      this.$buildTypeInputs.addClass("hidden");
      $currentInputs.removeClass("hidden");
    });
  }
}

Components.collection.register({
  selector: ".c-status-page-incident-form",
  klass: StatusPageIncidentForm,
});
